import { Link } from "react-router-dom";
import { parseCMSBold } from "@app/Helpers.js";
import "./style.scss";
import Lock from "./img/lock.svg?react";
import DOMPurify from "dompurify";

export default function PrizeCard({ title, copy, img, ident, href, disabled }) {
  return (
    <div className={`sub-reward-card-component `}>
      <Link to={href}>
        <div className="inner">
          <div className="img-wrapper">
            <picture>
              <source media="(min-width: 1020px)" srcSet={img} />
              <img src={img} alt={img} />
            </picture>
          </div>
          <div className={`award-info-wrapper ${href ? "with-button" : ""}`}>
            <div className="award-info">
              <p
                className="title"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(title))}}
              />
              {copy && (
                <>
                  <div className="divider"></div>
                </>
              )}
              {copy && (
                <div
                  className="copy"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(copy)}}
                />
              )}
            </div>
          </div>
        </div>
      </Link>
      {disabled === true && (
        <div className="lock-overlay">
          <Lock />
        </div>
      )}{" "}
    </div>
  );
}
